export { GlobalStyles } from './GlobalStyles';
export { palette } from './primitives/palette';
export { typography } from './primitives/typography';
